module.exports = __webpack_public_path__ + "ef89236668b6bafd4e4126a116abe4c4.pdf";